var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemTrash = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M13.598 2c1.532 0 2.863.935 3.234 2.271L17.312 6h3.577C21.503 6 22 6.447 22 7s-.497 1-1.111 1h-1.111v12c0 1.104-.996 2-2.222 2H6.444c-1.226 0-2.222-.896-2.222-2V8h-1.11C2.496 8 2 7.553 2 7s.497-1 1.111-1H6.69l.479-1.728C7.538 2.935 8.87 2 10.402 2Zm3.958 6H6.444v12h11.112zm-7.778 2c.614 0 1.11.447 1.11 1v6c0 .553-.496 1-1.11 1s-1.111-.447-1.111-1v-6c0-.553.496-1 1.11-1m4.444 0c.615 0 1.111.447 1.111 1v6c0 .553-.496 1-1.11 1s-1.112-.447-1.112-1v-6c0-.553.497-1 1.111-1m-.624-6h-3.196c-.51 0-.954.312-1.079.758L8.978 6h6.044l-.345-1.243c-.125-.445-.568-.757-1.08-.757"
})));
export default SvgGemTrash;